<div class="termos-page" style="color: #e1e1e1;">
  <div class="container">
    <div class="termos-card" style="color: #e1e1e1;">
      
      <header class="termos-header" style="text-align: center; margin-bottom: 40px;">
        <h1 class="termos-title" style="font-size: 2.5rem; color: #ffffff; margin-bottom: 8px;">Termos de Serviço</h1>
        <p class="termos-subtitle" style="color: #aaaaaa;"><strong>Última atualização:</strong> 22 de julho de 2024</p>
      </header>

      <main>
        <p>Bem-vindo(a) ao El Rey Metrics!</p>
        <p>Estes Termos de Serviço ("Termos") governam o seu uso do nosso aplicativo e serviços ("Serviço"). Ao acessar ou usar o nosso Serviço, você concorda em cumprir estes Termos. Se você não concorda com qualquer parte dos termos, não poderá acessar o Serviço.</p>

        <div>
          <h2 style="color: #f2f2f2;">1. Descrição do Serviço</h2>
          <p>O El Rey Metrics é uma plataforma que permite aos usuários conectar suas contas do Instagram e Facebook para analisar métricas de desempenho de seus perfis e de suas campanhas de marketing. O Serviço acessa dados fornecidos pelas APIs do Instagram e do Facebook para gerar relatórios, análises e insights, ajudando você a otimizar sua estratégia de marketing digital.</p>
          <p class="highlight" style="background: #2d2f36; color: #f8e89a; border-left: 4px solid #ffc107; padding: 12px 16px; border-radius: 4px;">O acesso e o uso da plataforma são privados e restritos a clientes que possuem um contrato de serviço ativo com a El Rey Labs.</p>
        </div>

        <div>
          <h2 style="color: #f2f2f2;">2. Aceitação dos Termos</h2>
          <p>Ao usar o nosso Serviço, você confirma que:</p>
          <ul>
            <li>Possui um contrato de serviço vigente com a El Rey Labs que rege o uso desta plataforma.</li>
            <li>Leu, entendeu e concorda em estar vinculado a estes Termos.</li>
            <li>Tem a idade legal para firmar um contrato vinculativo.</li>
            <li>Cumprirá todas as leis e regulamentos aplicáveis.</li>
          </ul>
        </div>

        <div>
          <h2 style="color: #f2f2f2;">3. Coleta e Uso de Dados</h2>
          <p>Para fornecer nossos services, precisamos acessar certas informações de suas contas do Instagram e do Facebook.</p>
          
          <div class="data-section" style="background: #23252b; border-left: 4px solid #4da3ff; padding: 16px; border-radius: 6px;">
            <h3 style="color: #cccccc;">Dados Acessados:</h3>
            <ul>
              <li><strong>Dados do Instagram:</strong> Informações do seu perfil público, métricas de publicações (curtidas, comentários, salvamentos), dados de stories, e informações demográficas de seguidores (de forma agregada e anônima).</li>
              <li><strong>Dados de Campanhas do Facebook:</strong> Métricas de desempenho de suas campanhas de anúncios, como alcance, impressões, cliques, custo por resultado e outras métricas relacionadas.</li>
            </ul>
          </div>

          <div class="data-section" style="background: #23252b; border-left: 4px solid #4da3ff; padding: 16px; border-radius: 6px;">
            <h3 style="color: #cccccc;">Finalidade do Uso:</h3>
            <ul>
              <li>Os dados coletados são utilizados exclusivamente para fornecer as funcionalidades do nosso Serviço, como a geração de relatórios de métricas, análises de desempenho e insights.</li>
              <li>Não compartilharemos seus dados pessoais ou de suas campanhas com terceiros, exceto quando exigido por lei ou com o seu consentimento explícito.</li>
              <li>O uso e a transferência de informações recebidas das APIs do Google para qualquer outro aplicativo aderirão à Política de Dados do Usuário dos Serviços de API do Google, incluindo os requisitos de Uso Limitado.</li>
            </ul>
          </div>

          <p>Ao conectar suas contas, você nos autoriza a coletar, armazenar e processar esses dados em conformidade com nossa <strong><a href="/politica-de-privacidade" style="color: #71b5ff;">Política de Privacidade</a></strong>. Você também concorda com os Termos de Serviço e Políticas de Privacidade do Facebook (Meta), que podem ser encontrados em seus respectivos sites.</p>
        </div>

        <div>
          <h2 style="color: #f2f2f2;">4. Acesso à Conta e Segurança</h2>
          <ul>
            <li>O acesso ao El Rey Metrics é concedido pela El Rey Labs após a celebração de um contrato de serviço, não havendo registro público.</li>
            <li>As credenciais de login (usuário e senha) são pessoais e intransferíveis.</li>
            <li>Você é responsável por manter a confidencialidade de suas credenciais e por todas as atividades que ocorrem em sua conta.</li>
            <li>Você concorda em nos notificar imediatamente sobre qualquer uso não autorizado de sua conta ou qualquer outra violação de segurança.</li>
          </ul>
        </div>

        <div>
          <h2 style="color: #f2f2f2;">5. Propriedade Intelectual</h2>
          <p>Todo o conteúdo, design, gráficos, e funcionalidades do Serviço são de propriedade exclusiva do El Rey Metrics e protegidos por leis de direitos autorais e propriedade intelectual. Você não pode copiar, modificar, distribuir ou usar qualquer parte do nosso Serviço sem nossa permissão prévia por escrito.</p>
        </div>

        <div>
          <h2 style="color: #f2f2f2;">6. Conduta do Usuário</h2>
          <p>Você concorda em não usar o Serviço para:</p>
          <ul>
            <li>Violar qualquer lei ou regulamento local, estadual, nacional ou internacional.</li>
            <li>Tentar obter acesso não autorizado aos nossos sistemas ou redes.</li>
            <li>Interferir ou interromper a integridade ou o desempenho do Serviço.</li>
          </ul>
        </div>

        <div>
          <h2 style="color: #f2f2f2;">7. Rescisão</h2>
          <p>Nós nos reservamos o direito de suspender ou encerrar seu acesso ao Serviço a qualquer momento, sem aviso prévio, por qualquer motivo, incluindo a violação destes Termos ou dos termos do seu contrato de serviço. Após a rescisão, seu direito de usar o Serviço cessará imediatamente.</p>
        </div>

        <div>
          <h2 style="color: #f2f2f2;">8. Isenção de Garantias e Limitação de Responsabilidade</h2>
          <p>O Serviço é fornecido "COMO ESTÁ" e "CONFORME DISPONÍVEL". Não garantimos que o serviço será ininterrupto, seguro ou livre de erros.</p>
          <p>Em nenhuma circunstância o El Rey Metrics ou seus diretores, funcionários ou afiliados serão responsáveis por quaisquer danos indiretos, incidentais, especiais ou consequenciais resultantes do uso ou da incapacidade de usar o Serviço.</p>
        </div>

        <div>
          <h2 style="color: #f2f2f2;">9. Alterações nos Termos</h2>
          <p>Reservamo-nos o direito de modificar estes Termos a qualquer momento. Notificaremos sobre quaisquer alterações publicando os novos Termos nesta página e, se as alterações forem significativas, forneceremos um aviso mais proeminente (como uma notificação por e-mail).</p>
        </div>

        <div>
          <h2 style="color: #f2f2f2;">10. Contato</h2>
          <p>Se você tiver alguma dúvida sobre estes Termos de Serviço, entre em contato conosco em:</p>
          <ul class="contact-list">
            <li><strong>E-mail:</strong> <a href="mailto:comercial@elreylabs.com.br" style="color: #4da3ff;">{{mail}}</a></li>
            <li><strong>Website:</strong> <a href="https://elreylabs.com.br" target="_blank" rel="noopener noreferrer" style="color: #4da3ff;">elreylabs.com.br</a></li>
          </ul>
        </div>
      </main>
    </div>
  </div>
</div>
